import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { Actions, DokobitLogin, useAbility, useUser } from '@/features/auth';

interface ProtectedRouteProps {
  redirectPath?: string;
  roles?: string[];
  // TODO: set type for subject
  permissions?: { action: Actions; subject: string }[];
}

const ProtectedRoute: React.FC<PropsWithChildren<ProtectedRouteProps>> = ({ redirectPath = '/', roles, permissions, children }) => {
  const { data: user } = useUser();
  const ability = useAbility();

  if (!user) {
    return (
      <div className="h-full flex flex-col items-center pt-10 justify-center">
        <DokobitLogin />
      </div>
    );
  }

  if (roles?.length) {
    const userRoleMatch = roles.some((requiredRole) =>
      user.roles.some((userRole) => userRole === requiredRole || new RegExp(requiredRole, 'i').test(userRole)),
    );
    if (!userRoleMatch) {
      return <Navigate to={redirectPath} replace />;
    }
  }

  if (permissions) {
    if (!permissions.every(({ subject, action }) => ability?.can(action, subject) || false)) {
      return <Navigate to={redirectPath} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
